"use client";
import { jsx } from "react/jsx-runtime";
import { getFirstImageAsset } from "../../../../utils/contentstack/lib.js";
import { TextBuilderCard } from "../TextBuilderCardUI/index.js";
import { DEFAULT_NUMBER_OF_VISIBLE_LINES } from "./constants.js";
import { MainContainer } from "./styles.js";
import { COMPONENT_NAME } from "../constants.js";
const getIsEnableSeeMoreSeeLess = (data) => {
  if ("multiple_text_section_group" in data) {
    return data.text_section_config.see_more_see_less_capability;
  }
  return data.text_section_config.number_of_visible_lines !== 0;
};
const getNumberOfVisibleLines = (isEnableSeeMoreSeeLess, data) => {
  if (!isEnableSeeMoreSeeLess) return void 0;
  if ("multiple_text_section_group" in data) {
    return DEFAULT_NUMBER_OF_VISIBLE_LINES;
  }
  return data.text_section_config.number_of_visible_lines;
};
const renderTextBuilderCard = (data, textSectionAlignment, textSectionType, isEnableSeeMoreSeeLess, seeLessText, seeMoreText, uniqueId, locale, imageSize) => {
  var _a, _b, _c;
  if ("multiple_text_section_group" in data) {
    return data.multiple_text_section_group.map((card, index) => {
      var _a2, _b2, _c2;
      return /* @__PURE__ */ jsx(
        TextBuilderCard,
        {
          iconImage: getFirstImageAsset(
            (_a2 = card.text_section_icon) == null ? void 0 : _a2.icon_image
          ),
          alignment: textSectionAlignment,
          colorConfig: card.color_config,
          iconAltText: (_b2 = card.text_section_icon) == null ? void 0 : _b2.icon_alt_text,
          isEnableSeeMoreSeeLess,
          numberOfVisibleLines: getNumberOfVisibleLines(
            isEnableSeeMoreSeeLess,
            data
          ),
          sectionType: textSectionType,
          seeLessText,
          seeMoreText,
          textSections: card.text_section_content,
          externalLink: data == null ? void 0 : data.external_link,
          uniqueId,
          locale,
          predefinedIcon: (_c2 = card.text_section_icon) == null ? void 0 : _c2.select_predefined_icon,
          imageSize
        },
        `${textSectionType}-${textSectionAlignment}-${data.title}-${index}`
      );
    });
  }
  return /* @__PURE__ */ jsx(
    TextBuilderCard,
    {
      iconImage: getFirstImageAsset((_a = data.text_section_icon) == null ? void 0 : _a.icon_image),
      alignment: textSectionAlignment,
      colorConfig: data.text_section_config.color_config,
      iconAltText: (_b = data.text_section_icon) == null ? void 0 : _b.icon_image_alt_text,
      isEnableSeeMoreSeeLess,
      numberOfVisibleLines: getNumberOfVisibleLines(
        isEnableSeeMoreSeeLess,
        data
      ),
      sectionType: textSectionType,
      seeLessText,
      seeMoreText,
      textSections: data.text_section_content,
      externalLink: data == null ? void 0 : data.external_link,
      uniqueId,
      locale,
      predefinedIcon: (_c = data.text_section_icon) == null ? void 0 : _c.select_predefined_icon,
      imageSize
    },
    `text-section-${textSectionType}-${textSectionAlignment}`
  );
};
const TextBuilderUI = ({
  data,
  seeLessText = "",
  seeMoreText = "",
  uniqueId,
  locale = "en-us",
  imageSize
}) => {
  if (!data) return null;
  const {
    text_section_config: {
      text_section_alignment: textSectionAlignment,
      text_section_type: textSectionType
    }
  } = data;
  const isEnableSeeMoreSeeLess = getIsEnableSeeMoreSeeLess(data);
  const containerId = uniqueId ? `${uniqueId}_${COMPONENT_NAME}` : `${COMPONENT_NAME}`;
  return /* @__PURE__ */ jsx(MainContainer, { "data-testid": containerId, size: textSectionType, children: renderTextBuilderCard(
    data,
    textSectionAlignment,
    textSectionType,
    isEnableSeeMoreSeeLess,
    seeLessText,
    seeMoreText,
    uniqueId,
    locale,
    imageSize
  ) });
};
TextBuilderUI.displayName = "TextBuilderUI";
export {
  TextBuilderUI
};
